import { configureStore } from "@reduxjs/toolkit";
import userInterfaceSlice from "../Slices/userInterfaceSlice";
import settingsSlice from "../Slices/settingsSlice";
import assetsSlice from "../Slices/assetsSlice";
import soundsSlice from "../Slices/soundsSlice";
import animationsSlice from "../Slices/animationsSlice";
import loadingProgressReducer from "../Slices/loadingProgressSlice";
import freeRoundsSlice from "../Slices/freeRoundsSlice";
import replaySlice from "../Slices/replaySlice";

// Universal slices (provider-agnostic)
import gameSettingsSlice from "../Slices/gameSettingsSlice";
import spinSlice from "../Slices/spinSlice";
import featureGameSettingsSlice from "../Slices/featureGameSettingsSlice";
import potCollectionSlice from "../Slices/potCollectionSlice";

const store = configureStore({
  reducer: {
    // Shared slices
    userInterface: userInterfaceSlice,
    settings: settingsSlice,
    animations: animationsSlice,
    sound: soundsSlice,
    assets: assetsSlice,
    loadingProgress: loadingProgressReducer,
    freeRounds: freeRoundsSlice,
    replay: replaySlice,

    // Universal game slices (work with any RGS provider)
    game: gameSettingsSlice,
    spin: spinSlice,
    featureGame: featureGameSettingsSlice,
    potCollection: potCollectionSlice,
  },
});

// ── QA hook — lets `npm run test:respins` drive the game ──
// Present on the local dev server, and on builds made with
// REACT_APP_QA_HOOKS=true. Release builds set neither, so webpack strips this
// block from the bundle: players never receive it.
if (
  (process.env.NODE_ENV !== "production" ||
    process.env.REACT_APP_QA_HOOKS === "true") &&
  typeof window !== "undefined"
) {
  window.__STORE__ = store;
  import("../Slices/spinSlice").then((m) => {
    window.__SPIN__ = m;
  });
}

export default store;
